import { Dispatch } from 'redux';
import { actions } from 'sharedConstants';
import * as service from 'service';
import { GetCurrentUserFunction } from 'types';

export const getCurrentUser: GetCurrentUserFunction = () => async (dispatch: Dispatch<any>) => {
  dispatch({ type: actions.GET_CURRENT_USER_REQUEST });

  try {
    const user = await service.getCurrentUser();
    dispatch({
      type: actions.GET_CURRENT_USER_SUCCESS,
      payload: user.data,
    });
  } catch (error) {
    dispatch({ type: actions.GET_CURRENT_USER_FAIL });
  }
};

export const signOut = () => ({ type: actions.SIGN_OUT });
